module.exports = __webpack_public_path__ + "img/Warrior-dwarf-m-70.f04a1954.gif";